import React from "react";
import { Container, Kicker } from "@/components/shared";

export default function PageHero({ kicker, title, intro, children, dark = false }) {
  return (
    <section
      className={`border-b border-[#D6D3CB] ${dark ? "bg-[#1E1E2F] text-[#FFFAF3]" : "bg-[#FFFAF3]"}`}
    >
      <Container className="py-14 sm:py-20">
        <div className="max-w-3xl rise-in">
          {kicker && <Kicker className="mb-4">{kicker}</Kicker>}
          <h1
            className={`font-serif font-bold text-4xl sm:text-5xl tracking-tight leading-[1.08] ${
              dark ? "text-[#FFFAF3]" : "text-[#003366]"
            }`}
          >
            {title}
          </h1>
          {intro && (
            <p
              className={`font-sans text-base sm:text-lg leading-relaxed mt-6 ${
                dark ? "text-[#FFFAF3]/75" : "text-[#505A68]"
              }`}
            >
              {intro}
            </p>
          )}
          {children && <div className="mt-8">{children}</div>}
        </div>
      </Container>
    </section>
  );
}
